import { Field, Label, Radio as RadioHUI } from '@headlessui/react'
import { Circle } from '@phosphor-icons/react'
import type { ComponentProps, ReactNode } from 'react'

import { cx } from '../../cx'

type RadioProps = ComponentProps<typeof RadioHUI> & {
  label?: ReactNode
  static?: boolean
}

export function Radio({ label, className, static: isStatic, ...props }: RadioProps) {
  return (
    <Field className="flex items-center gap-2">
      <RadioHUI
        className={cx(
          'group flex size-12 shrink-0 cursor-pointer items-center justify-center rounded-2xl focus-visible:outline-active-light aria-disabled:cursor-not-allowed',
          {
            'bg-white hover:bg-hover-light active:bg-active-light aria-disabled:hover:bg-transparent':
              !isStatic,
          },
          className
        )}
        {...props}
      >
        <span className="hidden size-6 items-center justify-center rounded-full border-2 border-primary group-aria-checked:inline-flex group-aria-disabled:border-disabled-text">
          <Circle
            className="hidden size-4 fill-primary group-aria-checked:block group-aria-disabled:fill-disabled-text"
            weight="fill"
          />
        </span>
        <span className="size-6 items-center justify-center rounded-full border-2 border-primary group-aria-checked:hidden group-aria-disabled:border-disabled-text" />
      </RadioHUI>
      {label && <Label className="cursor-pointer font-body-copy">{label}</Label>}
    </Field>
  )
}
